'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../../../languageHandler');

var _MatrixClientPeg = require('../../../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _AccessibleButton = require('../../../elements/AccessibleButton');

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

var _Notifier = require('../../../../../Notifier');

var _Notifier2 = _interopRequireDefault(_Notifier);

var _SettingsStore = require('../../../../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var NotificationsSettingsTab = function (_React$Component) {
    (0, _inherits3.default)(NotificationsSettingsTab, _React$Component);

    function NotificationsSettingsTab() {
        (0, _classCallCheck3.default)(this, NotificationsSettingsTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationsSettingsTab.__proto__ || (0, _getPrototypeOf2.default)(NotificationsSettingsTab)).call(this));

        _this.state = {
            currentSound: "default",
            uploadedFile: null
        };
        return _this;
    }

    (0, _createClass3.default)(NotificationsSettingsTab, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _Notifier2.default.getSoundForRoom(this.props.roomId).then(function (soundData) {
                if (!soundData) {
                    return;
                }
                _this2.setState({ currentSound: soundData.name || soundData.url });
            });
        }
    }, {
        key: '_triggerUploader',
        value: function () {
            var _ref = (0, _bluebird.method)(function (e) {
                e.stopPropagation();
                e.preventDefault();

                this.refs.soundUpload.click();
            });

            function _triggerUploader(_x) {
                return _ref.apply(this, arguments);
            }

            return _triggerUploader;
        }()
    }, {
        key: '_onSoundUploadChanged',
        value: function () {
            var _ref2 = (0, _bluebird.method)(function (e) {
                if (!e.target.files || !e.target.files.length) {
                    this.setState({
                        uploadedFile: null
                    });
                    return;
                }

                var file = e.target.files[0];
                this.setState({
                    uploadedFile: file
                });
            });

            function _onSoundUploadChanged(_x2) {
                return _ref2.apply(this, arguments);
            }

            return _onSoundUploadChanged;
        }()
    }, {
        key: '_onClickSaveSound',
        value: function () {
            var _ref3 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                e.stopPropagation();
                                e.preventDefault();

                                _context.prev = 2;
                                _context.next = 5;
                                return (0, _bluebird.resolve)(this._saveSound());

                            case 5:
                                _context.next = 11;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context['catch'](2);

                                console.error('Unable to save notification sound for ' + this.props.roomId);
                                console.error(_context.t0);

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[2, 7]]);
            }));

            function _onClickSaveSound(_x3) {
                return _ref3.apply(this, arguments);
            }

            return _onClickSaveSound;
        }()
    }, {
        key: '_saveSound',
        value: function () {
            var _ref4 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var type, url;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this.state.uploadedFile) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                type = this.state.uploadedFile.type;

                                if (type === "video/ogg") {
                                    // XXX: I've observed browsers allowing users to pick a audio/ogg files,
                                    // and then calling it a video/ogg. This is a lame hack, but man browsers
                                    // suck at detecting mimetypes.
                                    type = "audio/ogg";
                                }

                                _context2.next = 6;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().uploadContent(this.state.uploadedFile, {
                                    type: type
                                }));

                            case 6:
                                url = _context2.sent;
                                _context2.next = 9;
                                return (0, _bluebird.resolve)(_SettingsStore2.default.setValue("notificationSound", this.props.roomId, _SettingsStore.SettingLevel.ROOM_ACCOUNT, {
                                    name: this.state.uploadedFile.name,
                                    type: type,
                                    size: this.state.uploadedFile.size,
                                    url: url
                                }));

                            case 9:

                                this.setState({
                                    uploadedFile: null,
                                    currentSound: this.state.uploadedFile.name
                                });

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _saveSound() {
                return _ref4.apply(this, arguments);
            }

            return _saveSound;
        }()
    }, {
        key: '_clearSound',
        value: function _clearSound(e) {
            e.stopPropagation();
            e.preventDefault();
            _SettingsStore2.default.setValue("notificationSound", this.props.roomId, _SettingsStore.SettingLevel.ROOM_ACCOUNT, null);

            this.setState({
                currentSound: "default"
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var currentUploadedFile = null;
            if (this.state.uploadedFile) {
                currentUploadedFile = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'span',
                        null,
                        (0, _languageHandler._t)("Uploaded sound"),
                        ': ',
                        _react2.default.createElement(
                            'code',
                            null,
                            this.state.uploadedFile.name
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'mx_SettingsTab' },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_heading' },
                    (0, _languageHandler._t)("Notifications")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section mx_SettingsTab_subsectionText' },
                    _react2.default.createElement(
                        'span',
                        { className: 'mx_SettingsTab_subheading' },
                        (0, _languageHandler._t)("Sounds")
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            (0, _languageHandler._t)("Notification sound"),
                            ': ',
                            _react2.default.createElement(
                                'code',
                                null,
                                this.state.currentSound
                            )
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            _AccessibleButton2.default,
                            { className: 'mx_NotificationSound_resetSound', disabled: this.state.currentSound == "default", onClick: this._clearSound.bind(this), kind: 'primary' },
                            (0, _languageHandler._t)("Reset")
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'h3',
                            null,
                            (0, _languageHandler._t)("Set a new custom sound")
                        ),
                        _react2.default.createElement(
                            'form',
                            { autoComplete: 'off', noValidate: true },
                            _react2.default.createElement('input', { ref: 'soundUpload', className: 'mx_NotificationSound_soundUpload', type: 'file', onChange: this._onSoundUploadChanged.bind(this), accept: 'audio/*' })
                        ),
                        currentUploadedFile,
                        _react2.default.createElement(
                            _AccessibleButton2.default,
                            { className: 'mx_NotificationSound_browse', onClick: this._triggerUploader.bind(this), kind: 'primary' },
                            (0, _languageHandler._t)("Browse")
                        ),
                        _react2.default.createElement(
                            _AccessibleButton2.default,
                            { className: 'mx_NotificationSound_save', disabled: this.state.uploadedFile == null, onClick: this._onClickSaveSound.bind(this), kind: 'primary' },
                            (0, _languageHandler._t)("Save")
                        ),
                        _react2.default.createElement('br', null)
                    )
                )
            );
        }
    }]);
    return NotificationsSettingsTab;
}(_react2.default.Component);

NotificationsSettingsTab.propTypes = {
    roomId: _propTypes2.default.string.isRequired
};
exports.default = NotificationsSettingsTab;
module.exports = exports['default'];
//# sourceMappingURL=NotificationSettingsTab.js.map